<template>
  <div>
    <v-app-bar color="primary" height="60" fixed>
      <v-toolbar-title>
        <img height="60" :src="logoImg" alt="RLP" style="vertical-align: middle" id="logoImg" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-center header-actions" v-if="$route.path !== '/login'">

        <!-- S:For Mobile Hambuger  Do not Remove this code-->
        <!-- Menu  -->
        <span class="header-hamburger-menu">
          <v-menu offset-y :rounded="1" :close-on-content-click="false" :nudge-width="100">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon elevation="0" class="header-top-action" v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-group v-for="([text], index) in btns" :key="index">
                <template v-slot:activator>
                  <v-list-item-icon v-if="getMainMenuIcon(text)" class="me-2">
                    <v-icon color="secondary" small>{{ getMainMenuIcon(text) }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ text }}</v-list-item-title>
                </template>

                <!-- 2nd Level Child -->
                <template v-for="(i, indexOfMenu) in menuKeys.length">
                  <v-list class="v-list_mobile" v-if="menuKeys[index] == indexOfMenu" :key="i">
                    <v-list-group v-for="child in permission[index].Childs" :key="child">
                      <template v-slot:activator>
                        <v-list-item-title>
                          <v-icon color="secondary" small v-text="child.Icon"></v-icon>
                          {{ child.FriendlyName }}
                        </v-list-item-title>
                      </template>
                      <!-- 3rd level -->
                      <v-list-item v-for="Childofchild in child.ChildOfChilds" :key="Childofchild" link>
                        <v-btn icon x-small class="mr-2" @click.stop="openMenuInNewTab(Childofchild.Url)">
                          <v-icon x-small color="secondary">mdi-open-in-new</v-icon>
                        </v-btn>
                        <router-link active-class="active" class="nav-link" :to="normalizeMenuUrl(Childofchild.Url)" exact>
                          <v-list-item-title v-text="Childofchild.FriendlyName"></v-list-item-title>
                        </router-link>
                      </v-list-item>
                    </v-list-group>
                  </v-list>
                </template>
              </v-list-group>
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-icon class="me-2">
                    <v-icon color="secondary" small>mdi-star</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Favorites</v-list-item-title>
                </template>
                <v-list class="v-list_mobile">
                  <v-list-item v-if="favLink.length == 0">
                    <v-list-item-title>Please add a page as favorites</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-for="child in favLink" :key="child.MenuId" link>
                    <v-btn icon x-small class="mr-2" @click.stop="openMenuInNewTab(child.Url)">
                      <v-icon x-small color="secondary">mdi-open-in-new</v-icon>
                    </v-btn>
                    <router-link active-class="active" class="nav-link" :to="normalizeMenuUrl(child.Url)" exact>
                      <v-list-item-title v-text="child.FriendlyName"></v-list-item-title>
                    </router-link>
                  </v-list-item>
                </v-list>
              </v-list-group>
            </v-list>
          </v-menu>
        </span>
        <!-- E:For Mobile Hambuger -->

        <!-- Menu drop down -->
        <template>
          <!-- S:Menu Buttons -->
          <v-menu offset-y v-for="([text], index) in btns" :key="text" :rounded="1"
            :close-on-content-click="true" :nudge-width="700" :nudge-bottom="5">
            <template v-slot:activator="{ attrs, on }">
              <v-tooltip bottom :disabled="!showHeaderIconTooltips">
                <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn @click="showDialog = false;"
                    class="customwhite--text btn-style header-top-action header-menu-button header-responsive-menu-action" text
                    v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }">
                    <v-icon v-if="getMainMenuIcon(text)" left small>{{ getMainMenuIcon(text) }}</v-icon>
                    <span class="header-menu-text">{{ text }}</span>
                  </v-btn>
                </template>
                <span>{{ text }}</span>
              </v-tooltip>
            </template>
            <!-- E:Menu Buttons -->
            <!-- S:List of 1st level Child -->
            <template v-for="(i, im) in menuKeys.length">
              <!-- Index of menu is needed beacuse in Vue.js Indexing starts with 1 -->
              <v-list v-if="menuKeys[index] == im" :key="i" class="web-list header-menu-list" :class="{
                'xs-height': $vuetify.breakpoint.xs,
                'sm-height': $vuetify.breakpoint.sm,
                'md-height': $vuetify.breakpoint.md,
                'lg-height': $vuetify.breakpoint.lg,
                'xl-height': $vuetify.breakpoint.xl
              }">
                <v-row class="px-3">

                  <v-col cols="12" sm="12" md="12" :lg="permission[index].Childs?.length > 6 ? 3 : 4"
                    class="py-4 px-5 header-menu-section" v-for="item in permission[index].Childs" :key="item" link>
                    <v-text class="header-menu-heading">
                      <v-icon color="secondary" small v-text="item.Icon"></v-icon>&nbsp;<v-text
                        class="font-weight-bold secondary--text">
                        {{ item.FriendlyName }} </v-text>
                    </v-text>
                    <!-- E:First Level -->
                    <!-- S:List of second Level Child -->
                    <v-col cols="12" class="pa-1" v-for="child in item.ChildOfChilds" :key="child" link>
                      <v-text class="pl-5 d-flex align-center header-submenu-link">
                        <v-btn icon x-small class="mr-2" @click.stop="openMenuInNewTab(child.Url)">
                          <v-icon x-small color="secondary">mdi-open-in-new</v-icon>
                        </v-btn>
                        <router-link active-class="active" class="nav-link" :to="normalizeMenuUrl(child.Url)" exact>{{
                          child.FriendlyName
                        }}</router-link>
                      </v-text>
                    </v-col>
                    <!-- E:List of Second Lebvl -->
                  </v-col>
                </v-row>
              </v-list>
            </template>
          </v-menu>
        </template>
        <!-- Sea -->

        <!-- Favourite Menu -->
        <v-menu offset-y nudge-bottom="14" min-width="230" class="overflow-y-auto"
          content-class="user-profile-menu-content">
          <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
            <v-tooltip bottom :disabled="!showHeaderIconTooltips">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-fade-transition mode="out-in" color="customwhite--text ml-10">
                  <v-btn text class="customwhite--text btn-style header-top-action header-menu-button header-responsive-menu-action"
                    v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                    <v-icon left small color="secondary">mdi-star</v-icon>
                    <span class="header-menu-text">Favorites</span>
                  </v-btn>
                  <v-btn icon small class="header-top-action header-favorites-compact-action"
                    v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                    <v-icon color="secondary">mdi-star</v-icon>
                  </v-btn>
                </v-fade-transition>
              </template>
              <span>Favorites</span>
            </v-tooltip>
          </template>
          <template>
            <v-list class="web-list">
              <v-row class="py-4" v-if="favLink.length == 0">
                <v-col cols="12" class="pa-1">
                  <v-text class="pl-5">
                    Please add a page as favorites
                  </v-text>
                </v-col>
              </v-row>
              <v-row class="py-4" v-if="favLink.length > 0">
                <v-col cols="12" class="pa-1" v-for="child in favLink" :key="child.MenuId" link>
                  <v-text class="pl-5 d-flex align-center">
                    <v-btn icon x-small class="mr-2" @click.stop="openMenuInNewTab(child.Url)">
                      <v-icon x-small color="secondary">mdi-open-in-new</v-icon>
                    </v-btn>
                    <router-link active-class="active" class="nav-link" :to="normalizeMenuUrl(child.Url)" exact>{{
                      child.FriendlyName
                    }}</router-link>
                  </v-text>
                </v-col>
              </v-row>
            </v-list>
          </template>
        </v-menu>
        <!-- Cart Menu -->
        <v-menu v-if="showCart" offset-y nudge-bottom="14" min-width="230" class="overflow-y-auto"
          content-class="user-profile-menu-content">
          <template v-slot:activator="{ on, attrs }">
            <v-fade-transition mode="out-in" color="customwhite--text ml-10">
              <v-btn icon small class="header-top-action" title="Favorite" v-bind="attrs" v-on="on">
                <template>
                  <v-badge v-if="cartCount > 0" color="secondary" overlap :content="cartCount" v-bind="attrs" v-on="on">
                    <v-icon color="secondary">mdi mdi-cart</v-icon>
                  </v-badge>
                  <v-icon v-else color="secondary">
                    mdi mdi-cart
                  </v-icon>
                </template>
              </v-btn>
            </v-fade-transition>
          </template>
          <template>
            <v-list class="v-list_fixed">
              <v-row class="py-4" v-if="cartList?.length == 0">
                <v-col cols="12" class="pa-1">
                  <v-text class="pl-5">
                    Please add items in your Cart
                  </v-text>
                </v-col>
              </v-row>
              <v-row class="py-4" v-else>
                <v-col cols="12" class="pa-3" v-for="item in cartList" :key="item.cart_line_id">
                  <v-row>
                    <v-col cols="6" class="pl-4">
                      <span class="ma-0 pa-0 secondary--text pl-3">
                        Part#
                      </span><br />
                      <span class="ma-0 pa-0 f-bold f-12 pl-3">
                        {{ item.Part_Number }}
                      </span>
                    </v-col>
                    <v-col class="pl-4">
                      <span class="ma-0 pa-0 secondary--text">
                        <!-- Qty -->
                      </span>
                      <span class="ma-0 pa-0 f-bold f-12 pl-3">
                        <v-btn title="Quantity" outlined class="mt-2" style="border-color: #DCDCDC"><span
                            class="primary--text">{{ item.qty }}</span></v-btn>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="py-0 my-0 pb-5 pa-3">
                      <!-- <span class="ma-0 pa-0 secondary--text pl-3">
                       
                      </span><br /> -->
                      <span class=" ma-0 pa-0 f-bold f-10 pl-3" title="Description">
                        <v-icon> mdi-text-short</v-icon> {{ item.Description }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-divider />
                </v-col>
                <v-btn class="btn-style mx-auto btn-style success" elevation="1" outlined color="cWhite"
                  @click="goToCart()">
                  <v-icon dark left style=""> mdi-cart-check</v-icon><span style="">Checkout </span>
                </v-btn>
                <v-btn class="btn-style mx-auto btn-style secondary" elevation="1" outlined color="cWhite"
                  @click="onClickClearCart()">
                  <v-icon dark left style=""> mdi-cart-off</v-icon><span style="">Clear Cart </span>
                </v-btn>
              </v-row>
            </v-list>
          </template>
        </v-menu>

        <span class="header-icon-divider"></span>
        <v-menu v-if="showGlobalSearch" v-model="searchMenuOpen" offset-y left :rounded="1"
          :close-on-content-click="false" :nudge-bottom="8"
          :min-width="$vuetify.breakpoint.xs ? 320 : 520" :max-width="$vuetify.breakpoint.xs ? 320 : 520"
          content-class="header-search-menu" transition="slide-y-transition">
          <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-btn icon small class="header-top-action header-search-button" title="Quick Search"
                  v-bind="{ ...menuAttrs, ...tooltipAttrs }" v-on="{ ...menuOn, ...tooltipOn }">
                  <v-icon color="customwhite">mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Quick Search</span>
            </v-tooltip>
          </template>
          <v-card class="header-search-panel" :class="{ 'header-search-panel--dark': $vuetify.theme.dark }"
            elevation="6">
            <v-row dense no-gutters align="start">
              <v-col cols="12" md="5" class="pr-md-2 pb-2 pb-md-0">
                <div class="header-search-native-select-wrap"
                  :class="{ 'header-search-native-select-wrap--dark': $vuetify.theme.dark }">
                  <select v-model="searchType" class="header-search-native-select">
                    <option v-for="item in searchTypeList" :key="item.search_code" :value="item.search_code">
                      {{ item.search_param }}
                    </option>
                  </select>
                  <v-icon small class="header-search-native-select__icon">mdi-menu-down</v-icon>
                </div>
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field ref="globalSearchInput" :loading="showGlobalLoader"
                  class="header-search-control f-uppercase" append-icon="mdi-magnify" dense outlined
                  :background-color="$vuetify.theme.dark ? '#2A2A2A' : 'white'" v-model="search" @input="getSearchData"
                  @click:clear="clearGlobalSearch" @keydown.esc="searchMenuOpen = false" v-texttrim clearable
                  hide-details>
                </v-text-field>
              </v-col>
            </v-row>
            <div v-if="showDialog || searchNoResults" class="header-search-results"
              :class="{ 'header-search-results--dark': $vuetify.theme.dark }">
              <div class="header-search-results__clear" @click="clearGlobalSearch">Clear Search</div>
              <div v-if="searchList.length > 0" class="header-search-results__list">
                <ul>
                  <li v-for="item in searchList" :key="item.id" @mousedown="showItem(item)">
                    <span>
                      <template>
                        <b># {{ item.order_num }}</b> <br />
                        Order Date: {{ item.order_date }} <br />
                        Created By: {{ item.created_by }}
                      </template>
                    </span>
                  </li>
                </ul>
              </div>
              <div v-else class="header-search-results__empty">
                No results found
              </div>
            </div>
          </v-card>
        </v-menu>
        <span v-if="showGlobalSearch" class="header-icon-divider"></span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="header-mode-toggle" :class="{ 'header-mode-toggle--dark': $vuetify.theme.dark }"
              :loading="themeSaving" :disabled="themeSaving" :aria-pressed="$vuetify.theme.dark.toString()"
              title="Toggle Mode" v-bind="attrs" v-on="on" @click="toggle_dark_mode">
              <span class="header-mode-toggle__knob">
                <v-icon x-small :color="$vuetify.theme.dark ? 'secondary' : 'primary'">
                  {{ $vuetify.theme.dark ? icons.mdiMoonWaningCrescent : icons.mdiWeatherSunny }}
                </v-icon>
              </span>
            </v-btn>
          </template>
          <span>{{ $vuetify.theme.dark ? 'Switch to light mode' : 'Switch to dark mode' }}</span>
        </v-tooltip>
        <span class="header-icon-divider"></span>
        <v-menu offset-y nudge-bottom="14" min-width="230" class="overflow-y-auto"
          content-class="user-profile-menu-content">
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="header-top-action user-menu-activator ml-2" title="User Menu" v-bind="attrs" v-on="on">
              <v-avatar size="32" class="user-menu-avatar">
                {{ userInitials }}
              </v-avatar>
              <v-icon color="customwhite" small class="ml-1">mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <div class="pb-3 pt-2">
              <div class="d-inline-flex flex-column justify-center ms-3" style="vertical-align: middle">
                <span class="text--primary font-weight-semibold mb-n1">
                  {{ fname }} {{ lname }}
                </span>
                <small class="text--disabled">{{ email }}</small>
              </div>
            </div>
            <v-divider></v-divider>
            <!-- Profile -->
            <v-list-item link @click="$router.push('/user-profile')">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--Printer Settings-->
            <v-list-item v-if="installId == 1" link @click="$router.push('/printer-settings')">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  mdi-printer-settings
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Printer Settings</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!--User Feedback-->
            <v-list-item link @click="$router.push('/report-issue')">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  mdi-comment-alert
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Report Issue / Feedback</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- User Impersonation -->
            <v-divider v-if="canAccessImpersonation"></v-divider>
            <v-list-item v-if="canAccessImpersonation" link @click="onClickBadge">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  mdi-account-supervisor-circle
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ getCurrentUserName ? 'Stop Impersonating' : 'Impersonate User' }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="getCurrentUserName">
                  {{ getCurrentUserName }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <!-- Logout -->
            <v-list-item link @click="logout">
              <v-list-item-icon class="me-2">
                <v-icon size="22">
                  mdi-logout
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
    <v-row>
      <v-col sm="11" md="11" lg="11">
        <v-dialog content-class="modal-popup" persistent v-model="Logout">
          <v-card rounded="rounded-xl" raised outlined class="center containerbox overflow-x-hidden">
            <v-card-title>
              <v-row>
                <v-col sm="12" md="12" lg="12"> Logging out </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col sm="12" md="12" lg="12" class="pa-10 pb-10">
                  Are you sure you want to log out?
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col sm="12" md="12" lg="12" class="pa-0 ma-0 pt-5 text-right">
                  <v-btn class="btn-style ma-2" outlined color="primarytext" elevation="1" @click="noLogout">
                    No, I want to continue..
                  </v-btn>
                  <v-btn class="btn-style ma-2 pl-2" outlined color="secondary" elevation="1" @click="yesLogout">
                    Log out
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <CommonDialog :showDialog="showDialogCart" :message="message" @onClickOkay="clearCart()"
      @onClickCancelled="onClickCloseDialog()" />
    <UserImpersonationDialog v-if="showImpersonationDialog" :showImpersonationDialog="showImpersonationDialog"
      @closeImpersonationDialog="closeImpersonationDialog" />

  </div>
</template>
<script>
import CommonDialog from "@/olp-components/common/common-dialog.vue";
import { mdiMoonWaningCrescent, mdiWeatherSunny } from '@mdi/js';
import EncryptUtility from '../utility/js/encrypt-utility';
import Utility from '../../shared/utility';
import axios from 'axios';
import { bus } from '../../main';
import adminService from '@/olp-components/admin/js/admin-service';
import UserImpersonationDialog from "../common/user-impersonation.vue";
import commonApiService from '../common/js/common-api-service';
import profilePreferencesService from '../user/js/profile-preferences-service';

export default {
  computed: {
    environmentHeader() {
      return 'Dev';
    },
    userInitials() {
      const firstInitial = (this.fname || "").trim().charAt(0);
      const lastInitial = (this.lname || "").trim().charAt(0);
      const emailInitial = (this.email || "").trim().charAt(0);
      return `${firstInitial}${lastInitial || (!firstInitial ? emailInitial : "")}`.toUpperCase() || "U";
    },
    showHeaderIconTooltips() {
      return this.$vuetify.breakpoint.width <= 1400;
    },
    canAccessImpersonation() {
      return this.hasPermission('User Impersonation') || !!this.getCurrentUserName;
    },
  },
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt('userID'),
      installId: EncryptUtility.localStorageDecrypt('installId'),
      getCurrentUserName: "",
      fname: '',
      favLink: [],
      lname: '',
      message: "Are you sure you want to clear cart?",
      showDialog: false,
      showDialogCart: false,
      showImpersonation: false,
      showImpersonationDialog: false,
      email: '',
      icons: {
        mdiMoonWaningCrescent,
        mdiWeatherSunny,
      },
      searchType: "",
      search: "",
      searchTypeList: [],
      showGlobalSearch: false,
      showCart: false,
      btns: [],
      menudata: '',
      menuKeys: [],
      searchList: [],
      searchNoResults: false,
      searchMenuOpen: false,
      fav: true,
      menu: false,
      userInfo: {},
      showGlobalLoader: false,
      themeSaving: false,
      hints: true,
      logoImg: EncryptUtility.localStorageDecrypt('installId') == 2 ? require('@/assets/images/OLP.png') :
        require('@/assets/images/RLP.png'),
      closeMenu: false,
      userName: 'Ashima',
      Logout: false,
      cartCount: 0,
      cartId: "",
      cartList: [],
      menuItems: [
        { title: 'Receiving', path: '/centralreceiving', icon: 'mdi-briefcase' },
      ],
      response: {},
      olpTheme: {
        primary: '#3c903b',
        secondary: '#f89554',
        menubreadcrums: "#FFFFFF",
        containerbox: "#FFFFFF",
        primarytext: '#3c903b',
        navlinks: '#3c903b',
        activeColor: "#2ed8b6",
        inactiveColor: "#ff5370",
        background: "#f4f5fa",
        tertiary: '#e9e7f7',
        customwhite: '#FFFFFF',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        customLightGrey: '#EBEEF3',
        cWhite: '#FFFFFF',
        red: "#DC143C"
      },
    };
  },
  async created() {
    this.installId == 2 ? this.$vuetify.theme.themes['light'] = this.olpTheme : ""
    if (this.checkTokenExpiry()) {
      let LoaderDialog = {
        visible: true,
        title: 'Please Wait...',
      };
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
      this.response = await this.getMenuList()
      {
        if (this.response.status == 200 && (this.response.data !== undefined && this.response.data.body !== undefined &&
          this.response.data.body.message !== undefined && this.response.data.body.message !== undefined && this.response.data.body.message !== null)) {
          let menuResponseData = this.response.data.body.message;
          if (menuResponseData !== "" && menuResponseData !== null && menuResponseData !== undefined) {
            this.permission = JSON.parse(menuResponseData).Menus;
            this.permission = this.sortMenu(this.permission)
            this.favLink = JSON.parse(menuResponseData).Favourites;
            let tempMenuKeys = Object.keys(this.permission);
            this.menuKeys = tempMenuKeys.map(Number);
            this.btns = this.permission.filter(menu => menu.FriendlyName != "User Impersonation").map(menu => [menu.FriendlyName]);
          }
        }
      }
      LoaderDialog.visible = false;
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
      let searchCatRes = await this.getSearchCategoryList()
      let searchTypeData = JSON.parse(searchCatRes.data.body.message)
      let urlList = JSON.parse(EncryptUtility.localStorageDecrypt('Url'))
      
      urlList?.forEach((element) => {
        element = element.replaceAll('"', "")
        if (element == "sales-order" || element == "purchase-order"){
          this.showGlobalSearch = true
          this.$nextTick(() => {
           this.$forceUpdate()
          })
        }
        searchTypeData?.forEach((ele) => {
          if (ele.url == element)
            this.searchTypeList.push(ele)
        })
      });
    }
    this.searchType = this.searchTypeList[0]?.search_code
    bus.$on('favorite', (data) =>
      this.favLink = JSON.parse(data.message).Favourites)
    bus.$on('cart', (data) => {

      if (data) {
        this.showCart = true;
        this.cartList = data
        this.cartCount = data?.length
      }
      else {
        this.showCart = false;
        this.cartList = []
        this.cartCount = 0
      }
    })
  },
  methods: {

    sortMenu(menu) {
      // Sort the main menu items based on Seq
      menu.sort((a, b) => a.Seq - b.Seq);
      // Recursively sort Childs, ChildOfChilds, and deeper levels
      menu.forEach(item => {
        if (item.Childs && item.Childs.length > 0) {
          this.sortMenu(item.Childs);
        }
        if (item.ChildOfChilds && item.ChildOfChilds.length > 0) {
          this.sortMenu(item.ChildOfChilds);
        }
        if (item.ChildOfChildOfChilds && item.ChildOfChildOfChilds.length > 0) {
          this.sortMenu(item.ChildOfChildOfChilds);
        }
      });
      return menu;
    },
    checkForImperonation(permission) {
      return this.hasPermission(permission);
    },
    hasPermission(permission) {
      const matchesPermission = (menu) => {
        if (!menu) {
          return false;
        }
        if (menu.FriendlyName === permission || menu.Id === permission) {
          return true;
        }
        return [menu.Childs, menu.ChildOfChilds, menu.ChildOfChildOfChilds]
          .some(children => Array.isArray(children) && children.some(matchesPermission));
      };
      return this.permission?.some(matchesPermission);
    },
    getMainMenuIcon(menuText) {
      const normalizedText = (menuText || "").toString().toLowerCase();
      if (normalizedText.includes("admin")) {
        return "mdi-application-cog";
      }
      if (normalizedText.includes("reports")) {
        return "mdi-file-chart-outline";
      }
      if (normalizedText.includes("utility")) {
        return "mdi-tools";
      }
      if (normalizedText.includes("inventory")) {
        return "mdi-package-variant-closed";
      }
      if (normalizedText.includes("sales order")) {
        return "mdi-clipboard-text-outline";
      }
      if (normalizedText.includes("purchase order")) {
        return "mdi-tag-outline";
      }
      if (normalizedText.includes("operations")) {
        return "mdi-cog-transfer-outline";
      }
      return "";
    },
    async onClickBadge() {
      if (!(EncryptUtility.localStorageDecrypt('orginalId'))) {
        this.showImpersonationDialog = true;
        EncryptUtility.localStorageEncrypt("orginalId", "")
      }
      else {
        EncryptUtility.localStorageEncrypt("userID", EncryptUtility.localStorageDecrypt('orginalId'));
        this.getCurrentUserName = "";
        let userObj = {
          pass: 3,
          imp_id: this.userInfo.impId,
          admin_user_id: EncryptUtility.localStorageDecrypt('orginalId'),
          imp_user_id: this.selectedUser || 0,
          comments: ""
        }
        let res = await commonApiService.postUserImpersonation("post", userObj, false);
        if (res) {
          let Alert = {
            type: "success",
            isShow: true,
            message: "Impersonation access for the user has been revoked."
          }

          this.$store.commit("ConfigModule/Alert", Alert);
          this.$router.push("/home");
          this.refreshHeader();
          EncryptUtility.localStorageEncrypt("orginalId", "")
        }
      }
    },
    closeImpersonationDialog() {
      this.showImpersonationDialog = false;
    },
    async getSearchData() {
      if (this.search) {
        this.showGlobalLoader = true
        this.searchNoResults = false;
        // this.search = this.search?.toUpperCase();
        if (this.search.length > 2 || !this.search) {
          let searchData = await this.postSearchData()

          // if(!searchData?.response){
          //   this.showGlobalLoader=false;
          // }
          if (searchData == "{response:NA}") {
            this.showGlobalLoader = false;
            this.searchList = [];
            this.showDialog = false;
            this.searchNoResults = true;
          }
          else {
            try {
              this.searchList = JSON.parse(searchData?.data?.body?.message) || [];
            } catch {
              this.searchList = [];
            }
            this.showGlobalLoader = false;
            if (this.searchList.length > 0) {
              // Converting the Date to MM/DD/YYYY/ HH:mm:ss Format
              this.searchList.forEach((element) => {
                element.order_date = Utility.displayDateFormat(element.order_date);
              });
              this.showDialog = true
              this.searchNoResults = false;
            }
            else {
              this.showDialog = false;
              this.searchList = []
              this.searchNoResults = true;
            }
          }
        }
        else {
          this.showGlobalLoader = false;
          this.showDialog = false;
          this.searchList = []
          this.searchNoResults = false;
        }
      }
      else {
        this.showGlobalLoader = false;
        this.showDialog = false;
        this.searchList = [];
        this.searchNoResults = false;
      }
    },
    clearGlobalSearch() {
      this.showDialog = false;
      this.showGlobalLoader = false;
      this.searchList = [];
      this.searchNoResults = false;
      this.search = "";
      if (this.searchMenuOpen) {
        this.focusGlobalSearchInput();
      }
    },
    focusGlobalSearchInput() {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const searchInput = this.$refs.globalSearchInput;
          searchInput?.focus?.();
          searchInput?.$el?.querySelector("input")?.focus();
        }, 75);
      });
    },
    normalizeMenuUrl(url) {
      if (!url) {
        return "/";
      }

      return url.startsWith("/") ? url : `/${url}`;
    },
    openMenuInNewTab(url) {
      const resolvedRoute = this.$router.resolve(this.normalizeMenuUrl(url));
      window.open(resolvedRoute.href, "_blank");
    },
    goToCart() {
      this.$router.push({
        name: "orderCheckOut",
      });
    },
    onClickClearCart() {
      this.showDialogCart = true;
    },
    onClickCloseDialog() {
      this.showDialogCart = false;
    },
    async clearCart() {
      let updateObj = {
        user_id: this.userId,
        pass: 4,
        cart_key: this.cartList[0].cart_id,
        cartlines: [],
        bu_key: EncryptUtility.localStorageDecrypt("olpBusinessSelected"),
      };

      let submitObj = { json: JSON.stringify(updateObj) };
      let res = await adminService.postCartUpdate("post", submitObj, true);
      if (res == "Cart removed") {
        this.showDialogCart = false;
        bus.$emit("cart", "");
        bus.$emit("refreshProduct", true)
        this.$router.push({
          name: "orderCart",
        });
      }
    },
    // to show Address
    showItem(item) {
      if (this.searchType == 'SO') {
        this.showGlobalLoader = false
        if (this.$route.path.includes('sales-order-details')) {
          this.$router.push(`/sales-order-details/${btoa(item.order_id.toString())}`, {})
        }
        else {
          this.$router.push(`/sales-order-details/${btoa(item.order_id.toString())}`)
        }
      }
      else {
        this.$router.push(`/purchase-order-details/${btoa(item.order_id.toString())}`)
      }
      this.showDialog = false;
      this.clearGlobalSearch()
      this.searchMenuOpen = false;
    },
    async postSearchData() {
      let req = {
        UserId: this.userId,
        Pass: 0,
        SearchStr: this.search.toUpperCase(),
        Search_Code: this.searchType,
      }
      try {
        return await axios.post('co/global_search', req)
      }
      catch (error) {
        return "{response:NA}"
      }
    },

    async getMenuList() {
      try {
        this.userId = EncryptUtility.localStorageDecrypt('userID');
        this.getUserDetails();
        const response = await axios.get(`ap/user_menu?user_id=${this.userId}`);
        return response;
      } catch (error) {
        let LoaderDialog = {
          visible: false,
          title: 'Please Wait...',
        };
        this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);

        throw error;
      }
    },

    async getSearchCategoryList() {
      return await axios.get(`co/global_search_type?UserId=${this.userId}`);
    },

    //Token expiry check on login loader issue fixes
    checkTokenExpiry() {
      this.localTime = EncryptUtility.localStorageDecrypt('JWTExp');
      this.expTime = this.localTime == undefined ? 0 : this.localTime * 1000;
      this.currTime = new Date().getTime();
      if (this.expTime > this.currTime) {
        return true;
      }
      else {
        localStorage.clear();
        sessionStorage.clear();
        this.$vuetify.theme.dark = false;
        return false;
      }
    },
    //Toggling dark mode
    async toggle_dark_mode() {
      const themeCode = this.$vuetify.theme.dark ? 'Light' : 'Dark';
      const previousThemeCode = this.$vuetify.theme.dark ? 'Dark' : 'Light';
      this.themeSaving = true;
      try {
        const response = await profilePreferencesService.updateTheme(this.userId, themeCode);
        if (response.status == 200 || response.status == 204) {
          profilePreferencesService.applyTheme(this.$vuetify, themeCode);
        } else {
          profilePreferencesService.applyTheme(this.$vuetify, previousThemeCode);
          let Alert = {
            type: 'error',
            isShow: true,
            message: response.data.message,
          };
          this.$store.commit('ConfigModule/Alert', Alert);
        }
      } catch (error) {
        profilePreferencesService.applyTheme(this.$vuetify, previousThemeCode);
        let Alert = {
          type: 'error',
          isShow: true,
          message: Utility.apiError(error),
        };
        this.$store.commit('ConfigModule/Alert', Alert);
      } finally {
        this.themeSaving = false;
      }
    },
    //Logout method
    logout() {
      this.Logout = true;
    },
    yesLogout() {
      this.Logout = false;
      this.$vuetify.theme.dark = false;
      Utility.logOut();
    },
    noLogout() {
      this.Logout = false;
    },
    //To get User basic details
    getUserDetails() {
      this.fname = EncryptUtility.localStorageDecrypt('fname');
      this.lname = EncryptUtility.localStorageDecrypt('lname');
      this.email = EncryptUtility.localStorageDecrypt('email');
    },
    async refreshHeader() {
      try {
        // Refresh menu list
        const menuResponse = await this.getMenuList();
        if (menuResponse.status === 200 && menuResponse.data?.body?.message) {
          const menuData = JSON.parse(menuResponse.data.body.message);
          this.permission = this.sortMenu(menuData.Menus);
          this.favLink = menuData.Favourites;

          // Reset and rebuild menu keys
          this.menuKeys = Object.keys(this.permission).map(Number);
          this.btns = this.permission.filter(menu => menu.FriendlyName != "User Impersonation").map(menu => [menu.FriendlyName]);
        }

        // Refresh search categories
        const searchCatRes = await this.getSearchCategoryList();
        if (searchCatRes.data?.body?.message) {
          const searchTypeData = JSON.parse(searchCatRes.data.body.message);
          this.updateSearchTypes(searchTypeData);
        }

        // Refresh user details
        this.getUserDetails();

        // Emit refresh event
        bus.$emit('headerRefreshed', true);
      } catch (error) {
        console.error('Error refreshing header:', error);
      }
    },

    updateSearchTypes(searchTypeData) {
      const urlList = EncryptUtility.localStorageDecrypt('Url')?.split(",") || [];
      this.searchTypeList = [];

      urlList.forEach(element => {
        element = element.replaceAll('"', "");
        if (element === "sales-order" || element === "purchase-order") {
          this.showGlobalSearch = true;
        }
        searchTypeData?.forEach(ele => {
          if (ele.url === element) {
            this.searchTypeList.push(ele);
          }
        });
      });

      // Reset search type to first available option
      this.searchType = this.searchTypeList[0]?.search_code;
    }

  },
  components: {
    CommonDialog,
    UserImpersonationDialog
  },
  mounted() {
    bus.$on("impersonateName", (data) => {
      this.getCurrentUserName = data?.userName;
      this.userInfo = data;
      if (EncryptUtility.localStorageDecrypt('orginalId')) {
        this.refreshHeader();
      }
    });

  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.clearGlobalSearch()
        this.searchMenuOpen = false
      }
    },
    searchMenuOpen(isOpen) {
      if (isOpen) {
        this.focusGlobalSearchInput();
      } else {
        this.showDialog = false;
        this.searchNoResults = false;
      }
    }
  },
};
</script>
<style>
a {
  text-decoration: none;
  cursor: pointer;
}

.search-type {
  position: relative;
  z-index: 9999 !important;
}

.web-list {
  overflow-y: auto;
  overflow-x: hidden;
}

.resultBox ul li {
  padding: 2px;
  list-style-type: circle;

}

.nav-link,
.theme--light.nav-link {
  color: var(--v-navlinks-base) !important;
}

.v-list_mobile {
  height: 200px;
  overflow-y: auto;
}

.v-list_fixed {
  max-height: 300px;
  width: 350px;
  overflow-y: auto;
  overflow-x: hidden;
}

.mobile-menu {
  top: 20px !important;
}

.searchInput {
  width: 100%;
  position: relative;
}

.header-actions {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  white-space: nowrap;
}

.header-search-menu {
  overflow: visible;
}

.header-icon-divider {
  align-self: center;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
  display: inline-block;
  height: 28px;
  margin: 0 14px 0 10px;
  vertical-align: middle;
}

.header-top-action {
  transition: background-color 0.18s ease, opacity 0.18s ease;
}

.header-top-action:hover,
.header-top-action:focus-visible {
  background-color: rgba(255, 255, 255, 0.14) !important;
}

.header-top-action::before {
  background-color: transparent !important;
}

.header-hamburger-menu,
.header-favorites-compact-action {
  display: none !important;
}

.header-menu-button {
  border-radius: 18px;
  height: 36px !important;
  font-size: 14px !important;
  margin-left: 4px;
  margin-right: 4px;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.header-menu-button .v-icon {
  font-size: 19px !important;
  margin-right: 7px !important;
}

@media (max-width: 1400px) {
  .header-menu-button {
    min-width: 38px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .header-menu-button .v-icon {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .header-menu-text {
    display: none;
  }
}

@media (max-width: 810px) {
  .header-hamburger-menu {
    display: inline-flex !important;
  }

  .header-responsive-menu-action {
    display: none !important;
  }
}

.header-menu-list .header-menu-heading,
.header-menu-list .header-submenu-link {
  border-radius: 4px;
  transition: background-color 0.18s ease;
}

.header-menu-list .header-menu-heading:hover,
.header-menu-list .header-submenu-link:hover {
  background-color: rgba(0, 91, 168, 0.08);
}

.theme--dark .header-menu-list .header-menu-heading:hover,
.theme--dark .header-menu-list .header-submenu-link:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.header-menu-list .header-menu-heading {
  display: flex;
  min-height: 24px;
  padding: 1px 4px;
}

.header-menu-list .header-submenu-link {
  margin: 0;
  min-height: 24px;
}

.header-search-button {
  margin-right: 4px;
}

.header-mode-toggle {
  align-items: center;
  background: #2f74ff !important;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  display: inline-flex;
  height: 32px !important;
  justify-content: flex-start;
  margin-left: 4px;
  min-width: 66px !important;
  padding: 0 5px !important;
  transition: background-color 0.18s ease;
  vertical-align: middle;
}

.header-mode-toggle:hover,
.header-mode-toggle:focus-visible {
  background: #3c7dff !important;
}

.header-mode-toggle::before {
  background-color: transparent !important;
}

.header-mode-toggle--dark {
  background: var(--v-primary-base) !important;
  border-color: rgba(248, 149, 84, 0.52);
  box-shadow: inset 0 0 0 1px rgba(248, 149, 84, 0.14);
  justify-content: flex-end;
}

.header-mode-toggle--dark:hover,
.header-mode-toggle--dark:focus-visible {
  background: var(--v-primary-base) !important;
}

.header-mode-toggle__knob {
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  display: inline-flex;
  height: 24px;
  justify-content: center;
  width: 24px;
}

.header-mode-toggle--dark .header-mode-toggle__knob {
  background: #101827;
  border: 1px solid rgba(248, 149, 84, 0.42);
}

.header-search-panel {
  border-radius: 4px;
  min-width: 0;
  padding: 12px;
  width: 100%;
}

.header-search-panel--dark {
  background: #1E1E1E !important;
  border: 1px solid #424242;
}

.header-search-control {
  margin: 0 !important;
}

.header-search-native-select-wrap {
  align-items: center;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  display: flex;
  height: 40px;
  position: relative;
  width: 100%;
}

.header-search-native-select-wrap:hover {
  border-color: rgba(0, 0, 0, 0.87);
}

.header-search-native-select-wrap:focus-within {
  border-color: var(--v-primarytext-base);
  border-width: 2px;
}

.header-search-native-select {
  appearance: none;
  background: transparent;
  border: 0;
  color: var(--v-primarytext-base);
  cursor: pointer;
  font-size: 0.9rem;
  height: 100%;
  outline: 0;
  padding: 0 30px 0 12px;
  width: 100%;
}

.header-search-native-select__icon {
  pointer-events: none;
  position: absolute;
  right: 8px;
}

.header-search-native-select-wrap--dark {
  background: #2A2A2A;
  border-color: #616161;
}

.header-search-native-select-wrap--dark:hover,
.header-search-native-select-wrap--dark:focus-within {
  border-color: #FFFFFF;
}

.header-search-native-select-wrap--dark .header-search-native-select,
.header-search-native-select-wrap--dark .header-search-native-select__icon {
  color: #FFFFFF !important;
}

.header-search-panel--dark .header-search-control,
.header-search-panel--dark .header-search-control input,
.header-search-panel--dark .header-search-control .v-select__selection,
.header-search-panel--dark .header-search-control .v-select__selection--comma,
.header-search-panel--dark .header-search-control .v-icon {
  color: #FFFFFF !important;
}

.header-search-panel--dark .header-search-control fieldset {
  border-color: #616161 !important;
}

.header-search-panel--dark .header-search-control .v-label {
  color: rgba(255, 255, 255, 0.72) !important;
}

.header-search-results {
  background: #FAFAFA;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  color: #1f1f1f;
  cursor: pointer;
  margin-top: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.header-search-results--dark {
  background: #1E1E1E;
  border-color: #424242;
  color: #FFFFFF;
}

.header-search-results__clear {
  border-bottom: 1px solid #E0E0E0;
  color: var(--v-primarytext-base);
  font-weight: 600;
  padding: 8px 10px;
}

.header-search-results--dark .header-search-results__clear {
  border-bottom-color: #424242;
}

.header-search-results__list {
  max-height: 250px;
  overflow-y: auto;
}

.header-search-results__list ul {
  list-style-type: none;
  margin: 0;
  padding: 8px 10px;
}

.header-search-results__list li {
  border-radius: 4px;
  list-style-type: none !important;
  padding: 8px;
}

.header-search-results__list li:hover {
  background: rgba(0, 91, 168, 0.08);
}

.header-search-results--dark .header-search-results__list li:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header-search-results__empty {
  color: rgba(0, 0, 0, 0.62);
  font-weight: 600;
  padding: 14px 18px;
  text-align: center;
}

.header-search-results--dark .header-search-results__empty {
  color: rgba(255, 255, 255, 0.72);
}

.user-menu-activator {
  border-radius: 18px;
  height: 36px !important;
  min-width: 0 !important;
  padding: 0 6px 0 2px !important;
  text-transform: none;
}

.user-menu-avatar {
  background: #6cb36d;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
}

@media (max-width: 1263px) {
  .header-icon-divider {
    height: 24px;
    margin-left: 8px;
    margin-right: 10px;
  }
}

@media (max-width: 600px) {
  #logoImg {
    height: 48px;
  }

  .header-icon-divider {
    margin-left: 6px;
    margin-right: 8px;
  }

  .header-mode-toggle {
    min-width: 58px !important;
  }

  .user-menu-activator {
    margin-left: 0 !important;
  }
}

.search-text-input {
  border-radius: 5;
  padding-left: 10
}

.resultBoxHeader {
  margin-top: -25px;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: #FAFAFA;
  width: 125%;
  position: absolute;
  max-height: 300px;
  overflow-y: auto;
  min-height: 0;
  cursor: pointer;
  z-index: 99;

}

.darkResultBoxHeader {
  margin-top: -25px;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: black;
  width: 125%;
  position: absolute;
  max-height: 300px;
  overflow-y: auto;
  min-height: 0;
  cursor: pointer;
  z-index: 99;
}

.text-black input {
  color: black !important;
}


.v-select.v-input--dense .v-select__selection--comma {
  color: black !important;
}

.xs-height {
  max-height: 200px;
}

.sm-height {
  max-height: 250px;
}

.md-height {
  max-height: 550px;
}

.lg-height {
  max-height: 2250px;
  overflow: hidden;
}

.xl-height {
  max-height: 2250px;
  overflow: hidden;
}

/* .nav-link:hover {
  color: #909090 !important;
} */
</style>
